import { _ as g } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.object.assign-7e79fd7b.js";
import { QUERIES as R } from "@ucl/shared-component-foundations";
import { c as h } from "./index-8b07dec9.js";
import "./es.object.keys-9d66766f.js";
import Q, { createContext as q, useState as $, useContext as T, useEffect as G, createElement as B } from "react";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import "./web.set-timeout-72b6430f.js";
import { useMediaQuery as J } from "./useMediaQuery.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import { useSlots as V } from "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import { Drawer as C } from "./drawer.js";
import { a as K } from "./index-5d0f31c6.js";
import { _ as X } from "./cloneSlots-622cf8c9.js";
import { Button as W } from "./button.js";
import { _ as w } from "./index-f5b44da3.js";
import v, { css as S } from "styled-components";
import { jsx as o, jsxs as N } from "react/jsx-runtime";
import "./accordion.js";
import "./es.array.join-c1bca812.js";
import "./aspectRatio.js";
import "./es.string.trim-6e13db75.js";
import "./es.string.small-23219181.js";
import "./es.date.to-string-6ed49878.js";
import "./es.regexp.to-string-e800d529.js";
import "./blogVideo.js";
import "./breadcrumb.js";
import "./bulkActionBar.js";
import "./buttonGroup.js";
import "./card.js";
import "./es.symbol.description-6025a604.js";
import "./es.parse-int-d7709701.js";
import "./cardIllustrationSection.js";
import "./es.parse-float-020a2ae0.js";
import "./es.regexp.constructor-6da4b85c.js";
import "./es.global-this-a7f40ce1.js";
import "./label.js";
import "./chip.js";
import "./es.string.match-5eb65eed.js";
import "./carousel.js";
import "./es.array.from-fe752fa6.js";
import "./es.function.name-b230e7d4.js";
import "./es.string.iterator-5de8a61e.js";
import "./es.string.starts-with-a6645e0a.js";
import "./es.string.link-fd2676c6.js";
import "./ctaButton.js";
import "./dataList.js";
import "./tableSearchView-f1b86ba0.js";
import "./es.number.constructor-fc5c8929.js";
import "@ucl/shared-component-foundations/foundations";
import "./es.array.find-index-cbf7640b.js";
import "./es.array.reduce-2985ed2c.js";
import "./es.array.splice-801adf1d.js";
import "./provider.js";
import "./filter.js";
import "./pagination.js";
import "./tableV1-80a39fe6.js";
import "./localeLanguages-75ceae62.js";
import "./es.array.index-of-084b82ab.js";
import "@ucl/ucl-translation";
import "./CalendarPickerInput-55c0d122.js";
import { Divider as Y } from "./divider.js";
import "./featureText.js";
import "./fileupload.js";
import "./focusTrap.js";
import "./globalAttributeBar.js";
import "./grid.js";
import "./hero.js";
import "./inLineAlert.js";
import "./jumplink.js";
import "./landingHero.js";
import "./landingPageVideo.js";
import "./list.js";
import "./mapMarker-3af5c1ff.js";
import "./index-8b032e93.js";
import "./popupTip-06ee114c.js";
import "./tooltip.js";
import "./es.string.search-d27ec57a.js";
import "./singleSelectInput-6bdc2a66.js";
import "./marketingDataList.js";
import "./modalVideo.js";
import "./modalWindow.js";
import "./pageHeader.js";
import "./phoneInput.js";
import "./es.array.unscopables.flat-map-40df3ae6.js";
import "./photoGalleryThumbnail.js";
import "./photosGalleryLightbox.js";
import "./progressBar.js";
import "./progressTracker.js";
import "./progressTrackerVertical.js";
import "./raisedSurface.js";
import "./readOnlySection.js";
import "./es.promise.resolve-c679daba.js";
import "./segmentControl.js";
import "./shareLinks.js";
import "./showMoreLess.styles-679d33f9.js";
import "./slot.js";
import "react-dom";
import "./tabPanels.js";
import "./tabs.js";
import "./tabsList.js";
import "./text.js";
import "./textDisclosure.js";
import "./timePickerInput.js";
import "./topBanner.js";
import "./videoPlayer.js";
import { getAriaProps as Z } from "./aria.js";
import "./export-cdcbfb2b.js";
import "./object-keys-719a5561.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./function-apply-4756dee6.js";
import "./array-method-is-strict-e5a3c878.js";
import "./environment-ddee5959.js";
import "./array-slice-79f93c56.js";
import "./validate-arguments-length-eb516e5b.js";
import "./isApiSupported-66660265.js";
import "./isClient-2f5bedbd.js";
import "./getTarget-19e0f923.js";
import "./useEventListener.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./useIsMounted.js";
import "./usePopoverIndex.js";
import "./getMetrics-953aa4f8.js";
import "./disclosure.js";
import "./closeButton.js";
import "./iconButton.js";
import "./combineRefs-c9ad2c39.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./an-instance-6efcfd6c.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./inherit-if-required-f068457b.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./set-species-5ede2ed0.js";
import "@ucl/shared-icons";
import "./index-f2264f1e.js";
import "./uniqueId.js";
import "./hTag.js";
import "./index-55eee02a.js";
import "./tslib.es6-59e1c9d8.js";
import "./objectDestructuringEmpty-69c165c0.js";
import "./string-trim-14e37ad3.js";
import "./es.function.bind-b4bdcd4b.js";
import "./useWindowSize.js";
import "./helperText.js";
import "./image.js";
import "./mediaDisclosureButton.js";
import "./species-constructor-00346775.js";
import "./taggedTemplateLiteralLoose-b7a1029e.js";
import "./getElementPosition-8d0dbc61.js";
import "./string-html-forced-a746405b.js";
import "./screenReaderOnly.js";
import "./accessibility.js";
import "./link.js";
import "./badge.js";
import "./useClient.js";
import "./useOnClickOutside.js";
import "./accordionPanel-89132988.js";
import "./actions.js";
import "./useSize.js";
import "./useContainmentCheck.js";
import "./slots.js";
import "./cardIllustration.js";
import "./childrenCountCheck-bbe924c6.js";
import "./hooks_internal.js";
import "./analytics.js";
import "./array-sort-7c90b530.js";
import "./spinner.js";
import "./tableAccordionItem-b42a40b9.js";
import "./currency.js";
import "./debounce-350c74b3.js";
import "./is-pure-c0f11fe0.js";
import "./this-number-value-32e86ff7.js";
import "./environment-is-node-a035d787.js";
import "./index-ebdb31f7.js";
import "./es.number.to-fixed-2c921bf4.js";
import "@ucl/shared-component-foundations/themeProvider";
import "@ucl/shared-component-foundations/themes";
import "./safe-get-built-in-a8d8c20c.js";
import "./index-0ec2583e.js";
import "./useIsFirstRender.js";
import "./usePagination.js";
import "./useInterval.js";
import "./useSwipe-7297d580.js";
import "./shareIcons.js";
import "./tabs.provider-ae82732d.js";
var ee = /* @__PURE__ */ v(C.Header).withConfig({
  displayName: "sidePanelstyles__SidePanelHeader",
  componentId: "sc-1xwfaf9-0"
})(["&.SidePanel__Header{", "}"], function(i) {
  var e = i.theme.components.sidePanel;
  return S(e.Header);
}), te = /* @__PURE__ */ v(C.Content).withConfig({
  displayName: "sidePanelstyles__SidePanelContent",
  componentId: "sc-1xwfaf9-1"
})(["&.SidePanel__Content{", "}"], function(i) {
  var e = i.theme.components.sidePanel;
  return S(e.Content);
}), F = /* @__PURE__ */ v(C.Footer).withConfig({
  displayName: "sidePanelstyles__SidePanelFooter",
  componentId: "sc-1xwfaf9-2"
})(["&.SidePanel__Footer{", "}"], function(i) {
  var e = i.theme.components.sidePanel;
  return S(e.Footer);
}), ie = /* @__PURE__ */ v.h2.withConfig({
  displayName: "sidePanelstyles__SidePanelNavHeader",
  componentId: "sc-1xwfaf9-3"
})(["&.SidePanel__NavHeader{", "}"], function(i) {
  var e = i.theme.components.sidePanel;
  return S(e.NavHeader);
}), ne = /* @__PURE__ */ v.div.withConfig({
  displayName: "sidePanelstyles__SidePanelListItem",
  componentId: "sc-1xwfaf9-5"
})(["&.SidePanel__ListItem{", "}"], function(i) {
  var e = i.theme.components.sidePanel;
  return S(e.ListItem);
}), oe = /* @__PURE__ */ v(W).withConfig({
  displayName: "sidePanelstyles__SidePanelNavItem",
  componentId: "sc-1xwfaf9-6"
})(["&.SidePanel__NavItem{", "}"], function(i) {
  var e = i.theme.components.sidePanel;
  return S(e.NavItem);
}), re = /* @__PURE__ */ v.details.withConfig({
  displayName: "sidePanelstyles__SidePanelSectionDetails",
  componentId: "sc-1xwfaf9-7"
})(["&.SidePanel__Section-Details{", "}"], function(i) {
  var e = i.theme.components.sidePanel;
  return S(e.SectionDetails);
}), ae = /* @__PURE__ */ v.summary.withConfig({
  displayName: "sidePanelstyles__SidePanelSectionSummary",
  componentId: "sc-1xwfaf9-8"
})(["&.SidePanel__Section-Summary{", "}"], function(i) {
  var e = i.theme.components.sidePanel;
  return S(e.SectionSummary);
}), me = /* @__PURE__ */ v.div.withConfig({
  displayName: "sidePanelstyles__SidePanelSummaryContent",
  componentId: "sc-1xwfaf9-9"
})(["&.SidePanel__Section-Summary-Content{", "}"], function(i) {
  var e = i.theme.components.sidePanel;
  return S(e.SummaryContent);
}), le = /* @__PURE__ */ v.li.withConfig({
  displayName: "sidePanelstyles__SidePanelListWrapper",
  componentId: "sc-1xwfaf9-10"
})(["&.SidePanel__MobileMenu__NavItem-List-wrapper{", " &.SidePanel__MobileMenu__NavItem-List-wrapper{display:block;},"], function(i) {
  var e = i.theme.components.dropdownMenuBase;
  return S(e.ListWrapper);
}), pe = /* @__PURE__ */ v.span.withConfig({
  displayName: "sidePanelstyles__SidePanelItemText",
  componentId: "sc-1xwfaf9-11"
})(["&.SidePanel__MobileMenu-NavItem-ItemText{", ";"], function(i) {
  var e = i.theme.components.dropdownMenuBase;
  return S(e.ItemText);
}), se = /* @__PURE__ */ v(w).withConfig({
  displayName: "sidePanelstyles__SidePanelMobileMenuDropdownMenuBase",
  componentId: "sc-1xwfaf9-12"
})(["&.SidePanel__MobileMenu-DropdownMenuBase{", ";"], function(i) {
  var e = i.theme.components.sidePanel;
  return S(e.MobileMenuDropdownMenuBase);
}), de = ["activeItem", "onSelect"], k = /* @__PURE__ */ q({
  variant: "default"
});
function ce(i) {
  var e = function(a) {
    var t = a.activeItem, n = a.onSelect, p = g(a, de), m = $(t), l = m[0], d = m[1], c = $(!1), f = c[0], _ = c[1];
    return /* @__PURE__ */ o(k.Provider, {
      value: {
        selectedItem: l,
        setSelectedItem: d,
        activeItem: t,
        onSelect: n,
        variant: p.variant,
        setMenuOpen: _,
        menuOpen: f
      },
      children: /* @__PURE__ */ o(i, Object.assign({}, p))
    });
  };
  return e;
}
var E = function(e) {
  return /* @__PURE__ */ o(Y, Object.assign({}, e, {
    margin: "12px 0px 12px 0px"
  }));
}, ue = ["label", "value", "itemKey", "_sectionKey"], ve = function(e) {
  var r = e.label, a = e.value, t = e.itemKey, n = t === void 0 ? r : t, p = e._sectionKey, m = g(e, ue), l = T(k), d = l.activeItem, c = l.onSelect, f = l.setSelectedItem, _ = l.setMenuOpen, M = r ?? n, b = n ?? r, y = function(P) {
    c == null || c(n, p), m.onClick == null || m.onClick(P, n, p), f == null || f(M), _ == null || _(!1);
  }, s = d === n, u = Z("option", {
    ariaSelected: s,
    ariaLabel: String(r)
  }), I = d === b;
  return /* @__PURE__ */ o(le, Object.assign({
    role: "option",
    "data-value": a,
    onKeyUp: function(P) {
      (P.code === "Space" || P.code === "Enter") && (P.preventDefault(), P.stopPropagation());
    },
    className: h(["SidePanel__MobileMenu__NavItem-List-wrapper"])
  }, u, m, {
    onClick: y,
    children: /* @__PURE__ */ o(pe, {
      className: h(["SidePanel__MobileMenu-NavItem-ItemText", {
        "SidePanel__MobileMenu-NavItem-ItemText--active": I
      }]),
      children: r
    })
  }));
};
const Se = /* @__PURE__ */ Q.memo(ve);
var U = function(e) {
  var r = e.children, a = e.headingLevel, t = a === void 0 ? "h2" : a, n = e.className;
  return /* @__PURE__ */ o(ie, {
    as: t,
    className: h(["SidePanel__NavHeader", n]),
    children: r
  });
}, _e = ["children", "onClick", "as", "className", "label", "itemKey", "_sectionKey", "disabled"], x = function(e) {
  var r, a, t = e.children, n = e.onClick, p = e.as, m = e.className, l = e.label, d = e.itemKey, c = d === void 0 ? l : d, f = e._sectionKey, _ = e.disabled, M = _ === void 0 ? !1 : _, b = g(e, _e), y = T(k), s = y.activeItem, u = y.onSelect, I = y.setSelectedItem, O = y.setMenuOpen, P = (r = l ?? (typeof t == "string" ? t : void 0)) != null ? r : c, L = (a = c ?? l) != null ? a : typeof t == "string" ? t : void 0, z = function(A) {
    u == null || u(L, f), n == null || n(A, L, f), I == null || I(P), O == null || O(!1);
  }, j = s === L;
  return /* @__PURE__ */ o(ne, {
    className: "SidePanel__ListItem",
    children: /* @__PURE__ */ o(oe, Object.assign({
      className: h("SidePanel__NavItem", {
        "SidePanel__NavItem--active": j
      }, {
        "SidePanel__NavItem--disabled": M
      }, m),
      fullWidth: !0,
      forwardedAs: p,
      active: j,
      "aria-current": j ? "page" : void 0,
      onClick: z
    }, b, {
      children: P
    }), P)
  });
}, Pe = ["title", "icon", "children", "className", "onClick", "sectionKey", "active"], D = function(e) {
  var r = e.title, a = e.icon, t = e.children, n = e.className, p = e.onClick, m = e.sectionKey, l = m === void 0 ? r : m, d = e.active, c = g(e, Pe), f = V(t, {}), _ = $(!!d), M = _[0], b = _[1], y = function(u) {
    p == null || p(u);
  };
  return G(function() {
    d && b(!0);
  }, []), /* @__PURE__ */ N(re, Object.assign({
    className: h(["SidePanel__Section-Details", n]),
    onClick: y,
    open: M
  }, c, {
    children: [/* @__PURE__ */ N(ae, {
      className: "SidePanel__Section-Summary",
      tabIndex: 0,
      onKeyUp: function(u) {
        (u.code === "Space" || u.code === "Enter") && u.stopPropagation();
      },
      children: [/* @__PURE__ */ N(me, {
        className: "SidePanel__Section-Summary-Content",
        children: [a && /* @__PURE__ */ o(K, {
          icon: a,
          size: "xs"
        }), r]
      }), /* @__PURE__ */ o(K, {
        className: "icon",
        icon: "caretRight",
        size: "s"
      })]
    }), f.rest.map(function(s) {
      if ((s == null ? void 0 : s.type) === D) {
        var u;
        return /* @__PURE__ */ o(D, Object.assign({}, s.props), (u = s.key) != null ? u : s.props.sectionKey);
      }
      if ((s == null ? void 0 : s.type) === x) {
        var I;
        return /* @__PURE__ */ o(x, Object.assign({}, s.props, {
          _sectionKey: l
        }), (I = s.key) != null ? I : s.props.itemKey);
      }
      return null;
    })]
  }));
};
D.NavItem = x;
var fe = function(e) {
  var r = e.children, a = X(r, [[x, function(t, n) {
    var p, m, l = (p = (m = t.label) != null ? m : typeof (t == null ? void 0 : t.children) == "string" ? t == null ? void 0 : t.children : void 0) != null ? p : t.itemKey;
    return /* @__PURE__ */ B(Se, Object.assign({}, t, {
      key: n,
      label: l,
      value: l
    }));
  }], [U, function(t, n) {
    return /* @__PURE__ */ B(w.Title, Object.assign({}, t, {
      key: n,
      as: t.headingLevel,
      className: h(["MobileMenu__NavHeader", t.className])
    }));
  }], [E, function(t, n) {
    return /* @__PURE__ */ B(w.Divider, Object.assign({}, t, {
      key: n
    }));
  }]]);
  return a;
}, he = function(e) {
  var r = e.children, a = e.footer, t = T(k), n = t.selectedItem, p = t.variant, m = t.menuOpen, l = m === void 0 ? !1 : m, d = t.setMenuOpen, c = d === void 0 ? function() {
  } : d;
  return /* @__PURE__ */ N(se, {
    menuOpen: l,
    handleMenuOpen: c,
    uniqueIdentifier: "sidePanelDropdown",
    className: "SidePanel__MobileMenu-DropdownMenuBase",
    children: [/* @__PURE__ */ o(w.Control, {
      children: /* @__PURE__ */ o(W, {
        fullWidth: !0,
        variant: "secondary",
        dataTestId: "control-container-test",
        rightIcon: /* @__PURE__ */ o(K, {
          icon: "caretDown"
        }),
        children: n
      })
    }), /* @__PURE__ */ o(w.Item, {
      value: "",
      label: "",
      className: "hide"
    }), /* @__PURE__ */ o(fe, {
      children: r
    }), p === "accordion" && /* @__PURE__ */ o(F, {
      className: "Drawer__Footer",
      children: a
    })]
  });
}, ye = ["children", "header", "footer", "headerIcon", "variant"], Ie = function(e) {
  var r = e.children, a = e.header, t = e.footer, n = e.headerIcon, p = e.variant, m = p === void 0 ? "default" : p, l = g(e, ye), d = J(R.mobile);
  return d ? /* @__PURE__ */ o(he, {
    footer: t,
    children: r
  }) : /* @__PURE__ */ N(C, Object.assign({
    isOpen: !0
  }, l, {
    _disableTransition: !0,
    className: h(["SidePanel"]),
    _noBackDrop: !0,
    size: "small",
    placement: "left",
    children: [/* @__PURE__ */ N(ee, {
      className: "SidePanel__Header",
      children: [/* @__PURE__ */ o(K, {
        icon: n,
        size: "xl"
      }), /* @__PURE__ */ o(C.Header.Title, {
        className: h([{
          "SidePanel__Header--Title-accordion": m === "default"
        }]),
        children: a
      })]
    }), /* @__PURE__ */ o(te, {
      className: h(["SidePanel__Content--" + m, "SidePanel__Content"]),
      children: r
    }), /* @__PURE__ */ o(F, {
      className: "SidePanel__Footer",
      children: t
    })]
  }));
}, H = ce(Ie);
H.NavItem = x;
H.NavHeader = U;
H.Section = D;
H.SectionDivider = E;
export {
  H as SidePanel
};
